import {
    MapContainer,
    TileLayer,
    Marker,
    Popup
  } from "react-leaflet";
  
  import L from "leaflet";
  
  import "leaflet/dist/leaflet.css";
  import "leaflet-defaulticon-compatibility";
  import "leaflet-defaulticon-compatibility/dist/leaflet-defaulticon-compatibility.css";
  
  const offices = [
    {
      name: "Main Office",
      city: "Dakar",
      address: "N 37 Rue Abdou Karim Bourgi, Dakar",
      lat: 14.7167,
      lng: -17.4677,
      type: "hq"
    },
    {
      name: "Dakar Airport Office",
      city: "Dakar Airport",
      address: "Airport Blaise Diagne",
      lat: 14.7397,
      lng: -17.4902,
      type: "office"
    },
    {
      name: "Abidjan",
      city: "Abidjan",
      address: "Marcory Zone 4",
      lat: 5.295,
      lng: -3.986,
      type: "office"
    },
    {
      name: "Conakry",
      city: "Conakry",
      address: "Kaloum",
      lat: 9.5092,
      lng: -13.7122,
      type: "office"
    },
    {
      name: "Jaipur",
      city: "Jaipur",
      address: "Central Spine",
      lat: 26.9124,
      lng: 75.7873,
      type: "office"
    },
    {
      name: "Libreville",
      city: "Gabon",
      lat: 0.4162,
      lng: 9.4673,
      type: "upcoming"
    },
    {
      name: "Dubai",
      city: "UAE",
      lat: 25.2048,
      lng: 55.2707,
      type: "upcoming"
    },
    {
      name: "Douala",
      city: "Cameroon",
      lat: 4.0423,
      lng: 9.7548,
      type: "upcoming"
    }
  ];
  
  const hqIcon = new L.DivIcon({
    className: "",
    html: `
      <div style="
        width:32px;
        height:32px;
        border-radius:50%;
        background:#112D4E;
        border:4px solid white;
        display:flex;
        align-items:center;
        justify-content:center;
        color:white;
        font-size:16px;
        font-weight:bold;
        box-shadow:0 4px 14px rgba(17,45,78,.35);
      ">
        ★
      </div>
    `,
    iconSize: [32,32],
    iconAnchor: [16,16]
  });
  
  const officeIcon = new L.DivIcon({
    className: "",
    html: `
      <div style="
        width:22px;
        height:22px;
        border-radius:50%;
        background:#3F72AF;
        border:3px solid white;
        box-shadow:0 3px 10px rgba(63,114,175,.3);
      "></div>
    `,
    iconSize: [22,22],
    iconAnchor: [11,11]
  });
  
  const upcomingIcon = new L.DivIcon({
    className: "",
    html: `
      <div style="
        width:22px;
        height:22px;
        border-radius:50%;
        border:3px dashed #3F72AF;
        background:white;
        box-shadow:0 3px 10px rgba(63,114,175,.18);
      "></div>
    `,
    iconSize: [22,22],
    iconAnchor: [11,11]
  });
  
  export default function OfficeMap() {
    return (
      <MapContainer
        center={[13, 10]}
        zoom={2}
        scrollWheelZoom={false}
        style={{
          width: "100%",
          height: "500px",
          borderRadius: "20px"
        }}
      >
        <TileLayer
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
  
        {offices.map((office, index) => (
          <Marker
            key={office.name}
            position={[office.lat, office.lng]}
            icon={
                office.type === "hq"
                  ? hqIcon
                  : office.type === "office"
                  ? officeIcon
                  : upcomingIcon
              }
          >
            <Popup>
                <h4 style={{marginBottom:8}}>
                    {office.name}
                </h4>

                <p style={{margin:0}}>
                    {office.city}
                </p>

                {office.type === "hq" && (
                    <div
                    style={{
                        marginTop:10,
                        color:"#3F72AF",
                        fontWeight:700
                    }}
                    >
                    ★ Headquarters
                    </div>
                )}

                {office.type === "office" && (
                    <div
                    style={{
                        marginTop:10,
                        color:"#4c7a52",
                        fontWeight:700
                    }}
                    >
                    ✓ Operational Office
                    </div>
                )}

                {office.type === "upcoming" && (
                    <div
                    style={{
                        marginTop:10,
                        color:"#3F72AF",
                        fontWeight:700
                    }}
                    >
                    Opening Soon
                    </div>
                )}
                </Popup>
          </Marker>
        ))}
      </MapContainer>
    );
  }